import { Box } from '@chakra-ui/react';
import { ActiveParameters } from 'types';
import SpecificationView from './SpecificationView';

interface ProcessMenuItemProps {
  parameters: string[];
  params: ActiveParameters;
  isUpdated: boolean;
}

const ProcessMenuItem = ({ parameters, params, isUpdated }: ProcessMenuItemProps) => {
  const renderParameters = parameters
    .filter((key: string | number) => !!params[+key])
    .map((key: any) => {
      const { displayName, parameterType, value, visible, values } = params[+key];

      if (parameterType === 'reference' && !visible) {
        return null;
      }

      const foundVal = values ? values.find((val) => val.value.toString() === value.toString()) : null;

      return (
        <SpecificationView key={key} name={displayName} value={foundVal?.displayName ?? value} disabled={!isUpdated} />
      );
    });

  return <Box>{renderParameters}</Box>;
};
export default ProcessMenuItem;
